<template>
  <div class="newsbox">
    <template v-for="(item, index) in newsList">
      <div class="news_font" :key="index">
        <div @click="read(item.id)">
          <div class="news_title">{{ item.newsTitle }}</div>
          <div class="news_time">
            {{ new Date(item.createTime).toLocaleString() }}
          </div>
          <div class="news_con">{{ item.newsSummary }}</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { newslist } from "../../tools/ajax";

export default {
  data() {
    return {
      newsList: []
      // arrays: [],
      // arr2: [],
      // arr3: [],
      // arr4: []
    };
  },
  methods: {
    read(id) {
      this.$router.push({ path: "/newsdetail", query: { uid: id } });
    },
    getNewsList() {
      newslist({
        pageNo: 1,
        pageSize: 3
      }).then(res => {
        this.newsList = res.result.records;
        // if (this.newsList != "") {
        //   for (const item in this.newsList) {
        //     // 获取某个时间格式的时间戳
        //     var stringTime = this.newsList[item].createTime;
        //     var timestamp2 = new Date(stringTime).getTime();
        //     this.newsList[item].createTime = timestamp2;
        //     this.arrays.push(this.newsList[item]);
        //   }
        //   // 创建动态排序函数，根据传递的值对对象进行排序：
        //   function compare(property) {
        //     return function(a, b) {
        //       var value1 = a[property];
        //       var value2 = b[property];
        //       return value2 - value1;
        //     };
        //   }
        //   // 根据时间排序
        //   this.arrays.sort(compare("createTime"));
        //   // 得出置顶新闻 isTop
        //   // console.log(this.arrays);
        //   for (const items in this.arrays) {
        //     if (this.arrays[items].isShow == "true") {
        //       if (this.arrays[items].isTop == "true") {
        //         this.arr2.push(this.arrays[items]);
        //       } else if (this.arrays[items].isTop == "false") {
        //         this.arr3.push(this.arrays[items]);
        //       }
        //     }
        //   }
        //   this.arr4 = [...this.arr2, ...this.arr3];
        // }
      });
    }
  },
  created() {
    this.getNewsList();
  }
};
</script>
<style scoped>
.newsbox {
  display: flex;
  align-items: center;
}
.news_font {
  padding: 20px;
  width: 420px;
  height: 323px;
  background-color: #fff;
  text-align: left;
  margin: 0 12px;
}
.news_font > div {
  cursor: pointer;
}
.news_title {
  font-size: 20px;
  color: #000;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  margin-top: 10px;
}
.news_time {
  font-size: 18px;
  color: #999999;
  margin-top: 10px;
}
.news_con {
  font-size: 18px;
  color: #000;
  line-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  margin-top: 20px;
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue